<template>
  <div class="header-top-button-help" @click="getHelp"><div>?</div></div>
  <ModalBlock
    title="Help"
    id="helpinfo"
    v-if="curhelp"
    @close="curhelp = undefined"
    iconc
    :xl="!curhelp.startsWith('No help available')"
  >
    <div v-html="curhelp"></div>
  </ModalBlock>
</template>

<script setup lang="ts">
import { api } from '@/libs/apiLocal'
import { ref } from 'vue'
import ModalBlock from '@/components/common/ModalBlock.vue'

const curhelp = ref<string | undefined>(undefined)

function getHelp() {
  // determinate menu to call
  if (curhelp.value) {
    curhelp.value = undefined
    return
  }
  const curpath = window.location.pathname
    .replace(/^\/backend/, '')
    .replace(/^\/datubazes/, '')
    .split('/')
  const lang = curpath[1] || 'lv'
  const menu_key = curpath.slice(2).join('-')
  api
    .get(`/menu/help/${lang}/${menu_key}/index.html`)
    .then((r) => {
      curhelp.value = r.data
    })
    .catch((e) => {
      e = String(e)
      if (e.startsWith('404') || e.startsWith('Not Found')) {
        curhelp.value = 'No help available for this page.'
      } else {
        curhelp.value = 'Some error occured!'
      }
    })
}
</script>
